<div class="flex-display height-100per">
  <div class="float-L width-86 view-height-overflow">
    <div class="pr-96px pr-1-25 pt-3">
      <div class="pcform pr-1-25 pt-0">
        <h1 class="top-heading content-blue" tabindex="0">{{cs_header}}</h1>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{cs_description}}</p>
        <h2 class="topic-heading font-16 content-blue bold" tabindex="0">{{cs_notesAboutUsingHeader}}</h2>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{cs_notesAboutUsingBody}}</p>
        <article class="bold font-14 mb-2" id="AboutUsingLink" role="heading" aria-level="2" [innerHTML]="cs_notesAboutUsingLink" tabindex="0"></article>
        <h2 class="topic-heading font-16 content-blue bold" tabindex="0">{{cs_copyrightNoticeHeader}}</h2>
        <p class="answer font-16 content-blue width-100" tabindex="0">{{cs_copyrightNoticeBody}}</p>
        <article class="bold font-14" id="CopyrightLink" role="heading" aria-level="2" [innerHTML]="cs_copyrightNoticeLink" tabindex="0"></article><br /><hr class="border-top-gray pb-24px">
        <div *ngFor="let cs of cs_content_arr" class="answer content-blue mb-1"><span (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="cs" tabindex="0"></span></div>
        <h2 class="topic-heading font-16 content-blue bold" tabindex="0">{{cs_supersededrequestheader}}</h2>
        <div *ngFor="let cs of cs_superseded_arr" class="answer content-blue mb-1"><span (click)="openLinkById($event)" [innerHTML]="cs" tabindex="0"></span></div>

        <div class="box"></div>
      </div>
      </div>
    </div>
  <div class="rightfloat float-R">
    <div class="rightfloatBG_padding">
      <span class="answer font-16 content-blue width-100" [innerHTML]="cs_archiveLibraryDescription" tabindex="0"></span>
      <img src="../../../assets/icons/Downloads.svg" class="download-image" alt="download icon">
      <span class="font-16" id="DownloadLink" role="heading" aria-level="2" [innerHTML]="cs_downloadLink" tabindex="0"></span>
    </div>
   </div>
  </div>
